<style lang="stylus">
.container {
  .res {
    font-family: roboto;
    font-size: 20px;
    font-weight: bold;
    padding: 6px 18px;
    background-color: #000;
    color: #fff;
    margin: 10px 0;
  }
}

/* Programs Section Styles */
.programs-section {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
  background-color: #ffffff;
  padding: 24px;
}

/* Divider styling */
.section-divider-dashboard {
  border-color: #BFBFBF !important;
  opacity: 1 !important;
}

/* Toggle Section */
.toggle-section-dashboard {
  padding: 20px 24px;
  background-color: #ffffff;
}

.toggle-container-dashboard {
  display: flex;
  gap: 4px;
  padding: 4px;
  background-color: #E8E8E8;
  border-radius: 100px;
  width: 100%;
  position: relative;
}

/* Sliding Background Indicator */
.toggle-background-slider {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 8px);
  height: calc(100% - 8px);
  background-color: #FFFFFF;
  border-radius: 100px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.toggle-background-slider.slide-right {
  transform: translateX(calc(100% + 8px));
}

.toggle-button-dashboard {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0px 24px;
  border: none;
  border-radius: 100px;
  background-color: transparent;
  cursor: pointer;
  transition: color 0.3s ease;
  font-family: Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #484848;
  height: 32px;
  position: relative;
  z-index: 2;
}

.toggle-button-dashboard.active {
  color: #191919;
}

.toggle-button-dashboard:hover:not(.active) {
  color: #191919;
}

.toggle-icon-dashboard {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.toggle-label-dashboard {
  white-space: nowrap;
}

/* Content Area */
.content-area-dashboard {
  padding-top: 0px;
}

.content-section-dashboard {
  width: 100%;
}

/* Section Header with Collapse */
.section-header-clickable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
}

.section-heading-dashboard {
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.03em;
  color: #191919;
  margin-bottom: 0;
  text-decoration: underline solid;
  text-underline-offset: -100%;
  text-decoration-thickness: 120%;
}

/* Expand Collapse Animation */
.expand-collapse-enter-active,
.expand-collapse-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}

.expand-collapse-enter-from,
.expand-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

.section-description-dashboard {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6B6B6B;
  margin-top: 8px;
  margin-bottom: 0;
}

/* Empty State */
.empty-state-dashboard {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.empty-state-dashboard p {
  font-family: Arial, sans-serif;
  font-size: 16px;
  color: #6B6B6B;
}

/* Certificates Empty State */
.empty-state-dashboard-certs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
}

.empty-state-title {
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.03em;
  color: #191919;
  margin-bottom: 8px;
  text-decoration: underline solid;
  text-underline-offset: -100%;
  text-decoration-thickness: 150%;
}

.empty-state-description {
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
  color: #6B6B6B;
  margin-bottom: 0;
}

/* Certificates List */
.certificates-list-dashboard {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.certificate-card-dashboard {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;
}

.certificate-card-dashboard:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.certificate-content-dashboard {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.certificate-info-dashboard {
  flex: 1;
}

.certificate-name-dashboard {
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #191919;
  margin-bottom: 4px;
}

.certificate-meta-dashboard {
  display: flex;
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #6B6B6B;
}

.certificate-status-dashboard {
  text-transform: capitalize;
}

.certificate-unregister-btn {
  flex-shrink: 0;
  text-transform: none;
  font-family: Arial, sans-serif;
  font-weight: 500;
}

/* Responsive adjustments */
/* Tablet adjustments */
@media (max-width: 960px) {
  .toggle-section-dashboard {
    padding: 16px;
  }

  .toggle-button-dashboard {
    font-size: 15px;
    padding: 0px 20px;
    gap: 6px;
  }
}

/* Mobile adjustments - Better touch targets */
@media (max-width: 600px) {
  .toggle-section-dashboard {
    padding: 12px 16px;
  }

  .toggle-container-dashboard {
    padding: 3px;
    gap: 3px;
  }

  .toggle-background-slider {
    top: 3px;
    left: 3px;
    width: calc(50% - 4.5px);
    height: calc(100% - 6px);
  }

  .toggle-background-slider.slide-right {
    transform: translateX(calc(100% + 3px));
  }

  .toggle-button-dashboard {
    font-size: 14px;
    padding: 0px 12px;
    height: 34px;
    gap: 6px;
  }

  .toggle-icon-dashboard {
    width: 18px;
    height: 18px;
  }

  .toggle-label-dashboard {
    font-size: 14px;
  }

  .content-area-dashboard {
    padding: 16px;
  }

  .section-heading-dashboard {
    font-size: 20px;
    line-height: 24px;
  }

  .certificate-card-dashboard {
    padding: 12px;
  }

  .certificate-name-dashboard {
    font-size: 15px;
  }

  .certificate-meta-dashboard {
    font-size: 13px;
  }

  .certificate-unregister-btn {
    font-size: 13px;
    padding: 4px 12px;
  }

  .empty-state-dashboard-certs {
    padding: 24px 16px;
  }

  .empty-state-title {
    font-size: 14px;
    line-height: 20px;
  }

  .empty-state-description {
    font-size: 14px;
    line-height: 20px;
  }
}

/* Extra small mobile devices */
@media (max-width: 400px) {
  .toggle-section-dashboard {
    padding: 12px;
  }

  .toggle-button-dashboard {
    font-size: 13px;
    padding: 0px 8px;
    gap: 4px;
  }

  .toggle-icon-dashboard {
    width: 16px;
    height: 16px;
  }

  .toggle-label-dashboard {
    font-size: 13px;
  }

  .content-area-dashboard {
    padding: 12px;
  }
}

.addCourses {
  strong {
    color: #191919;
  }
}

.greyLabel {
  background-color: #F2F2F2;
  text-color: black;
  padding: 1rem 1rem 1rem 1rem;

  a {
    color: #808B96;
    border-bottom: 2px solid #fdc63b;
  }

  p {
    padding-left: 20px;
    color: #808B96;
    line-height: 28px;
  }

  .heading {
    color: black;
  }
}

.black {
  background-color: black;
  color: white;
}

.grey-help {
  font-weight: 400;
  color: rgb(158, 158, 158);
  font-size: 17px;
}

@media (min-width: 960px) and (max-width: 1263px) {
  .mdGrey {
    padding: 37px 14px 20px 14px;
  }

  .mdGreyHelp {
    margin-bottom: 0px !important;
  }
}

html {
  scroll-behavior: smooth;
}

.sticky-anchors {
  z-index: 1;

  a {
    color: #191919;
    padding: 14.5px 6px;
    font-family: Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.03em;
    cursor: pointer;
    position: relative;
    transition: border-bottom 0.3s ease;
    flex: 1;
    text-align: center;
    border-bottom: 8px solid transparent;
  }

  a.active-anchor {
    color: #191919;
    border-bottom: 8px solid #8c1d40;
  }

  a:hover {
    color: #191919;
  }

  width: 100%;
  margin-left: 1%;
  margin-right: 1%;
  padding-bottom: 12px;
  background-color: white;
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  gap: 8px;
}

.mobile-anchor-border {
  width: 100%;
  border-bottom: 2px solid #DDDDDD;
}

@media only screen and (max-width: 320px) {
  .sticky-anchors {
    a {
      font-size: 10px;
    }
  }
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  padding-top: 10px;
  border-bottom: 2px solid #DDDDDD;
  margin-left: -16px;
}

.courseLabel strong {
  @media (max-width: 992px) {
    font-size: 21px;
  }
}

.newPathwaysEnrollment {
  padding: 0px 24px 32px !important;
}

.headline {
  .cross-icon {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 12px;

    @media (max-width: 400px) {
      right: 10px;
      top: 4px;
    }
  }
}

.v-progress-circular__underlay {
  fill: #F2F2F2;
  stroke: none !important;
}

.remainder-text {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
}

.section-title {
  font-size: 21px;

  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }
}


.plus-icon {
  margin: 4px;
}

/* Remove padding only from main dashboard columns */
.v-container > .v-row > .v-col[cols="12"][sm="12"][md="8"],
.v-container > .v-row > .v-col[cols="12"][sm="12"][md="4"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
<style scoped>
a.mobile-touch-target {
  display: inline-flex;
  align-items: center;
}

@media (max-width: 959.98px) {
  .container {
    padding: 24px !important;
  }
}
</style>
<template>
  <div>
    <!-- ACC-389: deep-link learner tried to self-enroll into a program-supported or
         not-covered course — self-registration is not available. -->
    <ProgramSupportedModal
      :model-value="modalQueue.isCurrent('partner-pay-deeplink')"
      @update:model-value="(v) => !v && modalQueue.dismiss('partner-pay-deeplink')"
      @browse="goToPayToEnrollCourses"
    />
    <NotificationPanel />
    <v-container v-if="notificationStore.panelOpen && notificationStore.panelExpanded">
      <NotificationFullScreen />
    </v-container>
    <v-container v-else class="container">
      <!-- Desktop toast banner (sm and up) -->
      <div
        v-if="toastDate && !toastDismissed && resultsFetched"
        class="d-none d-sm-flex align-center"
        style="
          background-color: #ffffff;
          border: 1px solid #e8e8e8;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
          border-radius: 8px;
          padding: 24px;
          gap: 12px;
          margin-bottom: 24px;
        "
      >
        <img :src="calendarIcon" alt="Calendar" class="flex-shrink-0" style="width: 48px; height: 48px" />

        <div class="d-flex flex-column flex-grow-1" style="gap: 12px; min-width: 0">
          <!-- Title row: date + text + close -->
          <div class="d-flex align-center" style="width: 100%">
            <span
              class="flex-grow-1"
              style="
                font-family: Arial, sans-serif;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.48px;
                color: #000000;
              "
            >
              <span v-if="toastFormattedDate" style="color: #747474; font-weight: 700">{{ toastFormattedDate }} -</span>
              {{ toastDate.text }}
            </span>
            <button
              class="flex-shrink-0 ml-4"
              style="
                width: 20px;
                height: 20px;
                padding: 0;
                border: none;
                background: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              @click="dismissToast"
            >
              <v-icon size="16" color="#bfbfbf">mdi-close</v-icon>
            </button>
          </div>

          <!-- Body row: link + button -->
          <div class="d-flex align-center" style="width: 100%">
            <div class="flex-grow-1" style="min-width: 0">
              <button
                style="
                  font-family: Arial, sans-serif;
                  font-size: 14px;
                  line-height: 18px;
                  color: #000000;
                  text-decoration: underline;
                  background: none;
                  border: none;
                  padding: 0;
                  cursor: pointer;
                "
                @click="scrollToDates"
              >
                View more important dates
              </button>
            </div>
            <UiButton
              v-if="showToastAddCourses"
              variant="gold"
              size="small"
              class="flex-shrink-0"
              @click="$router.push({ name: 'addCourses' })"
            >
              Add courses
            </UiButton>
          </div>
        </div>
      </div>

      <!-- Mobile toast banner (xs only) -->
      <div
        v-if="toastDate && !toastDismissed && resultsFetched"
        class="d-flex d-sm-none flex-column"
        style="
          background-color: #ffffff;
          border: 1px solid #e8e8e8;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
          border-radius: 8px;
          padding: 24px;
          gap: 10px;
          margin-bottom: 16px;
        "
      >
        <!-- Title row: date + text + close -->
        <div class="d-flex align-start" style="width: 100%; gap: 8px">
          <span
            class="flex-grow-1"
            style="
              font-family: Arial, sans-serif;
              font-weight: 700;
              font-size: 16px;
              line-height: 24px;
              letter-spacing: -0.48px;
              color: #000000;
            "
          >
            <span v-if="toastFormattedDate" style="color: #747474; font-weight: 700">{{ toastFormattedDate }} -</span>
            {{ toastDate.text }}
          </span>
          <button
            class="flex-shrink-0"
            style="
              width: 20px;
              height: 20px;
              padding: 0;
              border: none;
              background: none;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            @click="dismissToast"
          >
            <v-icon size="16" color="#bfbfbf">mdi-close</v-icon>
          </button>
        </div>

        <!-- Calendar icon -->
        <div class="d-flex justify-center">
          <img :src="calendarIcon" alt="Calendar" style="width: 48px; height: 48px" />
        </div>

        <!-- Add courses button (full width, session signup only) -->
        <UiButton
          v-if="showToastAddCourses"
          variant="gold"
          size="small"
          block
          @click="$router.push({ name: 'addCourses' })"
        >
          Add courses
        </UiButton>

        <!-- View more link -->
        <button
          style="
            font-family: Arial, sans-serif;
            font-size: 14px;
            line-height: 18px;
            color: #000000;
            text-decoration: underline;
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            text-align: center;
            width: 100%;
          "
          @click="scrollToDates"
        >
          View more important dates
        </button>
      </div>

      <error-component v-if="error" :message="error" v-on:clear="clear()" />

      <!-- Dashboard heading + notification bell (full width) -->
      <div v-if="resultsFetched" class="d-flex justify-space-between align-center mb-4">
        <div
          class="font-weight-bold"
          style="
            font-family: Arial, sans-serif;
            font-size: 40px;
            line-height: 44px;
            letter-spacing: -1.2px;
            color: #000000;
          "
        >
          Dashboard
        </div>
        <DashboardNotificationDropdown class="d-none d-md-block" />
      </div>

      <v-row>
        <div class="d-flex d-sm-none sticky-anchors py-0" id="myHeader">
          <a
            v-for="section in visibleSections"
            :key="section.id"
            @click="scrollToSection(section.id)"
            :class="{ 'active-anchor': activeSection === section.index }"
            class="anchor-link"
          >
            {{ section.label }}
          </a>
        </div>
        <div class="mobile-anchor-border d-flex d-sm-none" />
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-0 mt-4 mt-md-0" v-if="resultsFetched">
          <!-- Pathways & Certificates Section -->
          <PathwaysCertificatesSection
            v-if="shouldShowPathwaysCertificatesSection"
            :certificates="myCertificates"
            :unregistering-cert-id="unregisteringCertId"
            :has-pathway="isEnrolledInPathway"
            :is-pathways-allowed="isPathwaysAllowed"
            :is-certificates-available="isCertificatesAvailable"
            :is-enrolled-in-pathway="isEnrolledInPathway"
            :stay-on-certificates-tab="certificateRegistered"
            @unregister="unregisterFromCertificate"
            @pathway-enrolled="handlePathwayChange"
            @pathway-unenrolled="handlePathwayChange"
            @reload-certificates="fetchMyCertificates"
            @reloadDashboardOrPathway="reloadDashboardOrPathway"
          />

          <div
            id="courses"
            style="border: 1px solid #e0e0e0; border-radius: 12px; padding: 20px; margin-bottom: 24px"
            v-if="!courseCount && orientationCourse.length === 0"
          >
            <!-- Header -->
            <div class="d-flex align-center justify-space-between pb-3" style="gap: 12px">
              <div class="section-title font-weight-bold" :style="{ fontSize: $vuetify.display.xs ? '16px' : '20px' }">
                My Current Courses
              </div>
              <div
                class="addCourses d-flex align-center"
                style="cursor: pointer; font-size: 16px; font-weight: bold; white-space: nowrap; flex-shrink: 0"
                @click="
                  handleAddCoursesClick();
                  asuoDataLayerClick('Dashboard', '0', { section: 'My Current Courses' });
                "
                title="Go to Add Courses"
              >
                <span style="font-size: 24px; margin-right: 6px; line-height: 1">+</span>
                <span>Add courses</span>
              </div>
            </div>

            <!-- Empty State Message -->
            <p class="text-body-1 mb-0" style="color: #191919">
              It looks like you're not signed up for any courses yet.
            </p>

            <!-- Action Button -->
            <div class="mt-4">
              <Button
                variant="gold"
                size="large"
                class="text-none font-weight-bold px-6"
                @click="$router.push({ name: 'addCourses' })"
              >
                Start adding courses
                <template #endIcon>
                  <v-icon>mdi-arrow-right</v-icon>
                </template>
              </Button>
            </div>
          </div>
          <!-- Shared Courses panel (ACC-355) — same component as the Accelerate dashboard -->
          <div v-if="courseCount" id="courses" style="margin-bottom: 24px">
            <DashboardCoursesPanel
              variant="card"
              :course_sections="course_sections"
              @course-unenrolled="handleCourseUnenrolled"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pa-0 pl-md-6" v-if="resultsFetched">
          <v-row row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="padding: 0">
              <!--profile completion box-->
              <profile-completion
                :basicLearnerInfo="basicLearnerInfo"
                :demographicInfo="demographicInfo"
                :totalBasicInfo="totalBasicLearnerInfo"
                :basicInfoCurrent="basicLearnerInfoEntered"
                :totalDemographicInfo="totalDemographicInfo"
                :demographicInfoCurrent="demographicInfoEntered"
                :totalProgress="profileCompletionProgress"
                @reloadInfo="reloadDemographicInfo($event)"
              />

              <verification-status id="idVerificationBox" />
              <v-row column wrap style="margin: 0 0 2rem !important" v-if="!shouldRemoveCreditTracker()">
                <div style="width: 100%">
                  <my-progress
                    id="progress"
                    :pathwayCompletionDate="pathwayCompletionDate"
                    :pathwayName="pathway"
                    :earnedCredits="earnedCredits || 0"
                    :totalCredits="totalCredits || 0"
                    :minGPA="minimumGPA"
                    :pathwayData="pathwayData || {}"
                  />
                </div>
              </v-row>
              <DashboardCalendarCard id="calendar" vertical rounded style="margin: 0 0 2rem !important" />

              <!-- Success Coach Here -->
              <success-coach id="success-coach" v-if="shouldShowSupportCoachBox()" />

              <!-- Resources Section -->
              <div id="resources">
                <Resources :contents="resourcesContent" :partnerName="partnerName" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <CompletionModal
        v-if="isPathwayCompleted"
        :show="'pathway'"
        :showCanvasElement="showCanvasElement"
        @closePathwaysConfettiDialog="closePathwaysConfettiDialog()"
      />
      <CompletionModal
        v-if="modalQueue.isCurrent('celebrate-event')"
        :show="'confetti'"
        @closeConfettiDialog="closeConfettiDialog()"
        :celebrateEventMessage="celebrateEventMessage"
      />
      <CompletionModal
        v-if="modalQueue.isCurrent('course-completion')"
        :show="'courseCompletion'"
        @closeCourseCompletionConfettiDialog="closeCourseCompletionConfettiDialog()"
        :completedCoursesForConfetti="completedCoursesForConfetti"
        :showCanvasElement="showCanvasElement"
      />

      <!-- POK Certificate Congratulations Overlay (ACC-408: shown via the modal queue;
           the component fires its confetti internally when :visible becomes true) -->
      <PokCertificateDialog
        :visible="modalQueue.isCurrent('pok-cert')"
        :dialog-data="pokCertificateDialogData"
        @close="onPokCertificateDialogClose"
      />

      <ProfileCompletionModal
        v-if="completeProfile"
        :demographicInformation="demographicInfo"
        @close="reloadDemographicInfo($event)"
      />
    </v-container>

    <v-dialog v-model="showCreditRequestError" width="500">
      <v-card style="border-bottom: 8px solid #ffc627; text-align: center; background-color: white">
        <v-spacer style="height: 30px" />

        <v-col cols="12" sm="12" md="12" class="gradeChangeError">{{ alreadyRetriedForCreditMsg }}</v-col>
        <v-spacer style="height: 20px" />

        <v-col cols="10" sm="6" md="1" class="closeDialog">
          <v-btn style="background-color: #fec627; color: black; z-index: 999" @click="closeCreditRequestError()"
            >Close</v-btn
          >
        </v-col>
        <v-spacer style="height: 30px" />
      </v-card>
    </v-dialog>

    <!-- Course Unenroll Prompt/Popup Start -->
    <UnenrollDialog
      :show="unenrollCourse"
      :courseInfo="Object.assign({}, courseUnenrollmentInfo.courseInfo)"
      @openCloseUnenrollModel="openCloseUnenrollModel"
      @doUnenroll="doUnenroll"
      :paymentMethod="courseUnenrollmentInfo.paymentMethod"
      :enrollmentModeVerifiedDate="courseUnenrollmentInfo.enrollmentModeVerifiedDate"
      :courseDropDeadline="courseUnenrollmentInfo.courseDropDeadline"
      :enrollmentId="courseUnenrollmentInfo.enrollmentId"
      :buttonAction="courseUnenrollmentInfo.buttonAction"
      :enrollmentMode="courseUnenrollmentInfo.enrollmentMode"
      :isCourseRefunded="courseUnenrollInfo.isCourseRefunded"
      :verifiedTransactionId="courseUnenrollInfo.verifiedTransactionId"
    />
    <!-- Course Unenroll Prompt/Popup End -->

    <!--profile completion remainder modal (ACC-408: shown via the modal queue)-->
    <v-dialog
      :model-value="modalQueue.isCurrent('profile-reminder')"
      @update:model-value="(v) => !v && modalQueue.dismiss('profile-reminder')"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline head-modal" style="padding-left: 24px">
          Complete your profile
          <v-icon class="cross-icon" style="font-weight: normal" @click="modalQueue.dismiss('profile-reminder')"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="8" sm="8" md="10" lg="10">
              <p class="remainder-text">We are missing some demographic information about you.</p>
              <p class="remainder-text">
                This type of information helps us in our work to improve the product experience for each of our
                learners.
              </p>
            </v-col>
            <v-col cols="4" sm="4" md="2" lg="2" class="d-flex justify-center align-center">
              <v-progress-circular
                id="modal-profile-progress"
                :rotate="0"
                :size="80"
                :width="6"
                :modelValue="profileCompletionProgress"
              >
                <div
                  class="d-flex flex-column align-center justify-center text-center position-relative"
                  style="z-index: 10"
                >
                  <v-icon size="large" color="#000000" class="font-weight-black">mdi-account</v-icon>
                  <div class="font-weight-black text-body-2">
                    {{ profileCompletionProgress + '%' }}
                  </div>
                </div>
              </v-progress-circular>
            </v-col>
          </v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="py-2">
            <Button variant="gold" size="medium" @click="updateProfile()"> Update now </Button>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { DataLayerMixin } from '../mixins/dataLayerMixin';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { SessionInitializer } from '../mixins/sessionInitializer';
import confetti from 'canvas-confetti';
import CompletionModal from '../components/CompletionModal.vue';
import Resources from '../components/Resources.vue';
import ProfileCompletionModal from '../components/ProfileCompletionModal.vue';
import UnenrollDialog from '../components/UnenrollDialog.vue';
import DashboardCoursesPanel from '../components/courses/DashboardCoursesPanel.vue';
import PathwayRecommendationCard from '../components/pathways/PathwayRecommendationCard.vue';
import EnrolledPathwayCard from '../components/pathways/EnrolledPathwayCard.vue';
import Button from '@/components/ui/Button.vue';
import ProgramSupportedModal from '@/components/ProgramSupportedModal.vue';
import { Helper } from '../mixins/helpers.js';
import { useUserStore } from '../stores/user';
import { useCoursesStore } from '../stores/courses';
import { usePathwaysStore } from '../stores/pathways';
import { useUiStore } from '../stores/ui';
import { useCheckoutStore } from '../stores/checkout';
import { useModalQueueStore } from '../stores/modalQueue';
import { defineComponent } from 'vue';
import { isFeatureEnabled } from '../../feature-flags';
import PathwaysCertificatesSection from '../components/PathwaysCertificatesSection.vue';
import { useNotificationStore } from '@/stores/notifications';
import { useCourseDates } from '@/composables/useCourseDates';
import { useSessionMilestones } from '@/composables/useSessionMilestones';
import { todayDateStr } from '@/utils/dateUtils';
import calendarIcon from '@/assets/images/dashboard-dates-to-remember-calendar.svg';
import DashboardNotificationDropdown from '../components/accelerate/DashboardNotificationDropdown.vue';
import NotificationPanel from '../components/accelerate/NotificationPanel.vue';
import { useTour } from '@/tour';
import NotificationFullScreen from '../components/accelerate/NotificationFullScreen.vue';
import DashboardCalendarCard from '../components/accelerate/DashboardCalendarCard.vue';
import PokCertificateDialog from '../components/certificates/PokCertificateDialog.vue';
import { isCertificateEarned, certificateSentenceName } from '@/constants/certificates';
import { shouldRemoveCreditTracker } from '@/util/credit-tracker';

export default defineComponent({
  name: 'DashboardView',

  setup() {
    const { latestUpcomingDate, formatDateShort } = useCourseDates();
    const { sessionMilestoneEvents } = useSessionMilestones();
    const notificationStore = useNotificationStore();
    const modalQueue = useModalQueueStore();
    return { latestUpcomingDate, formatDateShort, sessionMilestoneEvents, calendarIcon, notificationStore, modalQueue };
  },

  data() {
    return {
      completedCoursesForConfetti: [],
      pathway: '',
      anchorValue: 1,
      error: '',
      selectedDegreePath: '',
      resultsFetched: false,
      course_sections: [],
      currentGPA: '0.0',
      degreePaths: [],
      shouldRefreshDashboard: false,
      celebrateEventMessage: '',
      pendingCelebrateEvent: null,
      isPathwayCompleted: false,
      showCanvasElement: true,
      pathwayId: '',
      isPathwayConfettiFired: false,
      pathwayCompletionDate: '',
      demographicInfo: {},
      basicLearnerInfo: {},
      completeProfile: false,
      collectDemographicInfo: false,
      pathwayData: {},
      noOfCourses: {
        completedCourses: '',
        progressCourses: '',
        remainingCourses: '',
        totalCourses: ''
      },

      resourcesContent: [],
      unenrollCourse: false,
      courseUnenrollInfo: {},
      showCreditRequestError: false,
      alreadyRetriedForCreditMsg: 'You have already requested for credit',
      earnedCredits: 0,
      totalCredits: 0,
      activeSection: 0,
      anchorSections: [],
      myCertificates: [], // Certificate list
      unregisteringCertId: null, // Track which certificate is being unregistered
      certificateRegistered: false, // Keeps the section on the Certificates tab after registering
      pendingViewAsCertificate: null, // Deferred certificate registration for view-as flow
      toastDismissedLocal: false,
      pokCertificateDialogData: null // { title, credential_url } for the modal
    };
  },

  watch: {
    shouldRefreshDashboard: {
      handler(newValue) {
        if (newValue) {
          this.getEnrollments((enrollments) => {});

          this.getBasicAndDemograhicInfo();
        }
      },
      immediate: false
    },

    'refreshDashboardPage.dashboard': {
      async handler() {
        this.getBasicAndDemograhicInfo();
        // Update collectDemographicInfo since mixin no longer does this
        this.collectDemographicInfo = (this.$conn.learnerData || {})._collectDemographicInfo;

        // Handle deferred certificate registration (viewAs + certificate URL params)
        if (this.isCertificateManagementEnabled && this.pendingViewAsCertificate) {
          const certParam = this.pendingViewAsCertificate;
          this.pendingViewAsCertificate = null;
          await this.registerForCertificate(certParam);
        }

        // Wrap getEnrollments in a promise so we can await it
        const enrollmentPromise = new Promise((resolve) => {
          this.getEnrollments((enrollments) => {
            resolve(enrollments);
          });
        });

        // Fetch enrollments and dashboard sections (pathways + certificates) in parallel
        await Promise.allSettled([enrollmentPromise, this.loadDashboardSections()]);

        // Refresh notifications for view-as user
        const userStore = useUserStore();
        this.notificationStore.loadReadState();
        this.notificationStore.setNotifications(
          userStore.apis.learnerData._studentAnnouncements,
          ((this.$conn.partnerData || {}).dashboardPageData || {}).studentPortalAnnouncement
        );
      },
      immediate: false
    }
  },
  computed: {
    isCertificateManagementEnabled() {
      return isFeatureEnabled('CERTIFICATE_MANAGEMENT');
    },
    isCertificatesAvailable() {
      // Certificates are available if:
      // 1. Feature flag is enabled AND
      // 2. Partner allows certificates
      const userStore = useUserStore();
      const learnerData = userStore.apis?.learnerData || this.$conn.learnerData;
      const partnerAllowsCertificates = learnerData?._isCertificatesAllowed === true;
      return this.isCertificateManagementEnabled && partnerAllowsCertificates;
    },
    shouldShowPathwaysCertificatesSection() {
      // Show PathwaysCertificatesSection if EITHER pathways OR certificates are available
      return this.isPathwaysAllowed || this.isCertificatesAvailable;
    },
    minimumGPA() {
      return this.$conn.learnerData?._generalAdmissionMinGPA;
    },
    courseUnenrollmentInfo() {
      return this.courseUnenrollInfo;
    },

    totalBasicLearnerInfo() {
      // Deep copy with Object.assign wasn't working so used parse with stringify
      let basicLearnerInfo = JSON.parse(JSON.stringify(this.basicLearnerInfo));
      basicLearnerInfo.country = null;
      delete basicLearnerInfo.name;
      if (Object.keys(basicLearnerInfo.mailingAddress).length > 0) {
        basicLearnerInfo.country = basicLearnerInfo.mailingAddress.country;
      } else {
        basicLearnerInfo.mailingAddress = null;
      }
      return Object.keys(basicLearnerInfo).length;
    },

    basicLearnerInfoEntered() {
      // Deep copy with Object.assign wasn't working so used parse with stringify
      let basicLearnerInfo = JSON.parse(JSON.stringify(this.basicLearnerInfo));
      delete basicLearnerInfo.name;
      basicLearnerInfo.country = null;

      if (Object.keys(basicLearnerInfo.mailingAddress).length > 0) {
        basicLearnerInfo.country = basicLearnerInfo.mailingAddress.country;
        delete basicLearnerInfo.mailingAddress.country;
      } else {
        basicLearnerInfo.mailingAddress = null;
      }
      return Object.values(basicLearnerInfo).filter((e) => {
        if (typeof e === 'object' && Object.keys(e || {}).length > 0) {
          if (Object.values(e).length === 4) return e;
        } else {
          return e;
        }
      }).length;
    },

    totalDemographicInfo() {
      return Object.keys(this.demographicInfo).length;
    },

    demographicInfoEntered() {
      return Object.values(this.demographicInfo).filter((e) => {
        return e;
      }).length;
    },

    profileCompletionProgress() {
      return this.collectDemographicInfo
        ? Math.round((this.demographicInfoEntered / this.totalDemographicInfo) * 100)
        : 100;
    },

    activeInactiveCourseLength() {
      const coursesStore = useCoursesStore();

      return coursesStore.enrollments.length;
    },

    canvasUserId() {
      return this.$conn.learnerData?._canvasUserId || null;
    },

    courseCount() {
      return this.course_sections.filter((e) => e.courses.length > 0).length > 0;
    },
    isEarnedAdmission() {
      return this.$conn.learnerData?._isEarnedAdmission;
    },
    isPathwaysAllowed() {
      // Check if pathways are allowed for this user
      const userStore = useUserStore();
      const learnerData = userStore.apis?.learnerData || this.$conn.learnerData;
      return learnerData?._isPathwaysAllowed;
    },
    isEnrolledInPathway() {
      // Use pathways store to check enrollment state from /api/pathways/my-pathway
      const pathwaysStore = usePathwaysStore();
      return pathwaysStore.isEnrolled;
    },
    pathwayState() {
      // Get the pathway state: 'new', 'recommendations', or 'enrolled'
      const pathwaysStore = usePathwaysStore();
      return pathwaysStore.pathwayState;
    },
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    },
    allSections() {
      const sections = [];

      // Add Pathways section only if pathways are allowed
      if (this.isPathwaysAllowed) {
        sections.push({ id: 'pathway', label: 'Pathways', index: 0 });
      }

      // Always add these sections
      sections.push({ id: 'courses', label: 'Courses', index: sections.length });
      sections.push({ id: 'calendar', label: 'Calendar', index: sections.length });
      sections.push({ id: 'progress', label: 'Progress', index: sections.length });
      sections.push({ id: 'resources', label: 'Resources', index: sections.length });

      return sections;
    },
    visibleSections() {
      // Show only 3 sections at a time, sliding window based on active section
      const maxVisible = 3;
      const total = this.allSections.length;

      if (total <= maxVisible) {
        return this.allSections;
      }

      // Calculate start index for the sliding window
      let startIndex = Math.max(0, this.activeSection - 1);

      // Adjust if we're at the end
      if (startIndex + maxVisible > total) {
        startIndex = total - maxVisible;
      }

      return this.allSections.slice(startIndex, startIndex + maxVisible);
    },
    toastDate() {
      const today = todayDateStr();
      const upcomingMilestones = (this.sessionMilestoneEvents || []).filter((e) => e.date >= today);
      const soonestMilestone = upcomingMilestones[0] || null;
      if (!this.latestUpcomingDate && !soonestMilestone) return null;
      if (!this.latestUpcomingDate) return soonestMilestone;
      if (!soonestMilestone) return this.latestUpcomingDate;
      return new Date(this.latestUpcomingDate.date) <= new Date(soonestMilestone.date)
        ? this.latestUpcomingDate
        : soonestMilestone;
    },
    showToastAddCourses() {
      return this.toastDate?.type === 'session_milestone' && this.toastDate?.id?.startsWith('session-start-');
    },
    toastFormattedDate() {
      if (!this.toastDate) return '';
      return this.formatDateShort(this.toastDate.date);
    },
    toastDismissKey() {
      if (!this.toastDate) return '';
      return `toast_dismissed_${this.toastDate.date}_${this.toastDate.id}`;
    },
    toastDismissed() {
      if (this.toastDismissedLocal) return true;
      if (!this.toastDismissKey) return false;
      try {
        return localStorage.getItem(this.toastDismissKey) === 'true';
      } catch {
        return false;
      }
    }
  },
  mixins: [AjaxLoader, DataLayerMixin, SessionInitializer, Helper],
  components: {
    CompletionModal,
    Resources,
    ProfileCompletionModal,
    UnenrollDialog,
    DashboardCoursesPanel,
    PathwayRecommendationCard,
    EnrolledPathwayCard,
    PathwaysCertificatesSection,
    Button,
    UiButton: Button,
    ProgramSupportedModal,
    DashboardNotificationDropdown,
    NotificationPanel,
    NotificationFullScreen,
    DashboardCalendarCard,
    PokCertificateDialog
  },
  props: {
    refreshDashboardPage: {
      type: Object
    },
    // The page load DashboardWrapper runs; this view renders it rather than loading again.
    pageLoad: {
      type: Promise,
      default: null
    },
    // DashboardWrapper's getDashboard() read, already in flight alongside enrollments.
    dashboardSectionsLoad: {
      type: Promise,
      default: null
    }
  },
  methods: {
    handleCourseUnenrolled(updatedSections) {
      // Immediately update course_sections to reflect the unenrollment
      this.course_sections = updatedSections;
    },
    checkPathwayNotifications() {},

    async fetchMyCertificates() {
      // Check feature flag first
      if (!isFeatureEnabled('CERTIFICATE_MANAGEMENT')) {
        return;
      }

      try {
        const learnerId =
          this.$conn.learnerData?._learnerId ||
          this.$conn.learnerData?._learnerApplicationId ||
          this.$conn.learnerData?.learnerId ||
          this.$conn.learnerData?.learnerApplicationId;

        if (!this.$conn.learnerData || !learnerId) {
          return;
        }

        const result = await this.$conn.getMyCertificates({
          ea_learner_application: learnerId
        });

        if (result.success && result.certificates) {
          this.myCertificates = result.certificates;
        } else if (result.certificates) {
          this.myCertificates = result.certificates;
        }

        // Fetch POK credentials from Aether and merge credential_url + state
        // into the matching certificate. Fire confetti for newly issued credentials.
        this._fetchAndMergePokCredentials(learnerId).catch((err) =>
          this.logError('Failed to fetch POK credentials', err)
        );
      } catch (error) {
        this.logError('Failed to fetch certificates', error);
      }
    },

    /**
     * Polls Aether for issued POK credentials, merges credential_url / pok_state
     * into myCertificates by pok_template_id, and fires confetti the first time
     * a credential moves to emitted/accepted.
     *
     * Matching priority per certificate:
     *   1. Exact:    cert.pok_certificate_id === pokCred.pok_id   (callback already ran)
     *   2. Fallback: cert.pok_template_id === pokCred.template_id (pick best state/date)
     */
    async _fetchAndMergePokCredentials(learnerId) {
      // Guard behind POK_CREDENTIALS feature flag — when off the backend returns []
      // so no further check needed here, but skip the API call entirely if flag is absent
      if (!isFeatureEnabled('POK_CREDENTIALS')) return;
      let pokCredentials;
      try {
        pokCredentials = await this.$conn.getPokCredentials({ ea_learner_application: learnerId });
      } catch {
        // Aether being unavailable must never break the certificate list
        return;
      }

      if (!pokCredentials || !pokCredentials.length) return;

      const ACTIVE_STATES = ['emitted', 'accepted'];

      // Helper: is `candidate` a better POK credential than `current`?
      const isBetter = (candidate, current) => {
        const cActive = ACTIVE_STATES.includes(candidate.state);
        const xActive = ACTIVE_STATES.includes(current.state);
        if (cActive && !xActive) return true;
        if (!cActive && xActive) return false;
        return new Date(candidate.earned_at) > new Date(current.earned_at);
      };

      // Build lookups for all three matching paths
      // Path 1: external_reference_id = connection_id sent at emit time (primary, exact)
      const byExternalRef = new Map(
        pokCredentials.filter((c) => c.external_reference_id).map((c) => [String(c.external_reference_id), c])
      );

      // Path 2: pok_id lookup (legacy — old callback stored pok_certificate_id)
      const byPokId = new Map(pokCredentials.map((c) => [c.pok_id, c]));

      // Path 3: best-per-template (last resort — ambiguous for shared templates)
      const bestByTemplate = new Map();
      for (const pokCred of pokCredentials) {
        if (!pokCred.template_id) continue;
        const existing = bestByTemplate.get(pokCred.template_id);
        if (!existing || isBetter(pokCred, existing)) {
          bestByTemplate.set(pokCred.template_id, pokCred);
        }
      }

      // Merge POK data into the local certificate list
      // Pre-populate claimedPokIds with ALL Path 1/2 exact matches BEFORE the map
      // so Path 3 can never steal a credential that belongs to another certificate,
      // regardless of the order myCertificates is processed.
      const claimedPokIds = new Set();
      for (const cert of this.myCertificates) {
        const exact =
          byExternalRef.get(String(cert.connection_id)) ||
          (cert.pok_certificate_id ? byPokId.get(cert.pok_certificate_id) : null);
        if (exact?.pok_id != null) claimedPokIds.add(exact.pok_id);
      }

      this.myCertificates = this.myCertificates.map((cert) => {
        let pokCred = null;

        // Path 1: exact match via external_reference_id (connection_id sent at emit)
        pokCred = byExternalRef.get(String(cert.connection_id)) || null;

        // Path 2: exact match via pok_certificate_id (old callback)
        if (!pokCred && cert.pok_certificate_id) {
          pokCred = byPokId.get(cert.pok_certificate_id) || null;
        }

        // Path 3: template_id fallback — only if the best credential for this template
        // has NOT already been claimed by another certificate via Path 1/2.
        // This prevents Health Education stealing Behavioral Sciences' URL when
        // they share a template_id but Health Education has no Aether entry.
        if (!pokCred && cert.pok_template_id) {
          const candidate = bestByTemplate.get(cert.pok_template_id) || null;
          if (candidate && !claimedPokIds.has(candidate.pok_id)) {
            pokCred = candidate;
          }
        }

        if (!pokCred) return cert;

        claimedPokIds.add(pokCred.pok_id);
        return {
          ...cert,
          credential_url: pokCred.credential_url,
          pok_state: pokCred.state,
          earned_at: pokCred.earned_at
        };
      });

      // Request the POK congratulations modal for the first newly issued credential
      // not yet shown. The queue (priority 60) shows one modal at a time and pauses
      // under the consent-gate blocker; the confetti fires on show (onModalQueueShow).
      for (const cert of this.myCertificates) {
        if (!cert.credential_url || !ACTIVE_STATES.includes(cert.pok_state)) continue;

        // Must actually be awarded — prevents confetti for certs the learner
        // hasn't earned yet (shared template URL steal scenario)
        if (!isCertificateEarned(cert)) continue;

        // DB flag is the source of truth — skip if already shown
        if (cert.pok_confetti_shown) continue;

        this.pokCertificateDialogData = {
          connection_id: cert.connection_id,
          title: certificateSentenceName(cert),
          credential_url: cert.credential_url
        };
        this.modalQueue.requestShow({ id: 'pok-cert', priority: 60 });
        // Only request one congratulations dialog at a time
        break;
      }
    },

    async loadDashboardSections(prefetched = null) {
      try {
        const dashboard = await (prefetched || this.$conn.getDashboard());

        // Pathways
        if (this.isPathwaysAllowed && dashboard.pathways) {
          const pathwaysStore = usePathwaysStore();
          pathwaysStore.setMyPathwayData(dashboard.pathways);
        }

        // Certificates
        if (this.isCertificateManagementEnabled && dashboard.certificates) {
          this.myCertificates = dashboard.certificates;

          // Merge POK credential_url from Aether into the certificate list
          const learnerId =
            this.$conn.learnerData?._learnerId ||
            this.$conn.learnerData?._learnerApplicationId ||
            this.$conn.learnerData?.learnerId ||
            this.$conn.learnerData?.learnerApplicationId;

          if (learnerId) {
            this._fetchAndMergePokCredentials(learnerId).catch((err) =>
              this.logError('Failed to fetch POK credentials', err)
            );
          }
        }

        // Log any partial errors
        if (dashboard._meta?.errors && Object.keys(dashboard._meta.errors).length > 0) {
          this.logError('Dashboard partial errors', dashboard._meta.errors);
        }
      } catch (error) {
        this.logError('Failed to load dashboard sections', error);
      }
    },

    async unregisterFromCertificate(certificate) {
      try {
        this.unregisteringCertId = certificate.connection_id;

        const result = await this.$conn.unregisterFromCertificate({
          credential_id: certificate.credential_id,
          ea_learner_application: certificate.ea_learner_application
        });

        const uiStore = useUiStore();
        uiStore.showSuccessNotification(
          'Certificate Removed',
          `The ${certificateSentenceName(certificate)} certificate has been removed from your dashboard.`,
          6000
        );

        // Refresh certificate list
        await this.fetchMyCertificates();
      } catch (error) {
        const uiStore = useUiStore();
        let errorTitle = 'Certificate Unregistration';
        let errorMessage = error.response?.data?.message || error.message || 'Failed to unregister from certificate';
        let alreadyRemoved = false;

        if (errorMessage.includes('already unregistered')) {
          errorTitle = 'Certificate Already Removed';
          errorMessage = 'The certificate has already been removed from your dashboard.';
          alreadyRemoved = true;
        } else if (errorMessage.includes('No registration found')) {
          errorMessage = 'No registration found for this certificate';
        }

        uiStore.showErrorNotification(errorTitle, errorMessage, 10000);

        // The card on screen is stale in this state — refresh so it matches the message
        if (alreadyRemoved) await this.fetchMyCertificates();
      } finally {
        this.unregisteringCertId = null;
      }
    },

    async registerForCertificate(certificateParam) {
      // Check feature flag first
      if (!isFeatureEnabled('CERTIFICATE_MANAGEMENT')) {
        return;
      }

      try {
        // Check multiple possible properties for learner ID
        const learnerId =
          this.$conn.learnerData?._learnerId ||
          this.$conn.learnerData?._learnerApplicationId ||
          this.$conn.learnerData?.learnerId ||
          this.$conn.learnerData?.learnerApplicationId;

        if (!this.$conn.learnerData || !learnerId) {
          return;
        }

        const uiStore = useUiStore();

        const result = await this.$conn.registerForCertificate({
          certificate: certificateParam,
          ea_learner_application: learnerId
        });

        // Check if registration was successful
        if (result.success && result.data) {
          uiStore.showSuccessNotification(
            'Registration Successful',
            `You have been registered for ${result.data.display_label || result.data.credential_name}`,
            8000
          );

          // Land the learner on the Certificates tab for the certificate they just registered for
          this.certificateRegistered = true;

          // Refresh certificate list
          await this.fetchMyCertificates();
        }
      } catch (error) {
        const uiStore = useUiStore();

        // Make error messages more user-friendly
        let errorMessage = error.response?.data?.message || error.message || 'Failed to register for certificate';

        // Convert technical error messages to user-friendly ones
        if (errorMessage.includes('already registered')) {
          errorMessage = 'You are already registered for this certificate';
        } else if (errorMessage.includes('not found')) {
          errorMessage = 'This certificate program could not be found';
        } else if (errorMessage.includes('not active')) {
          errorMessage = 'This certificate program is currently not available';
        }

        uiStore.showErrorNotification('Certificate Registration', errorMessage, 10000);
      }
    },

    async findCourseOfferingById(courseOfferingId) {
      try {
        // const coursesStore = useCoursesStore();

        // First, try to find the course offering from available pathway courses
        if (this.$conn.pathwayCourseList && this.$conn.pathwayCourseList._pathwayCourses) {
          let foundOfferingIds = [];
          for (const pathway of this.$conn.pathwayCourseList._pathwayCourses) {
            if (pathway._pathwayCourses) {
              for (const course of pathway._pathwayCourses) {
                if (course._courseOfferingData) {
                  for (const offering of course._courseOfferingData) {
                    foundOfferingIds.push(offering._courseOfferingId);
                    if (offering._courseOfferingId === courseOfferingId) {
                      // Create courseOffering object in expected format
                      return {
                        courseOfferingId: offering._courseOfferingId,
                        courseOfferingCanvasId: offering._canvasCourseId,
                        courseInfo: {
                          courseName: offering._courseName || course._courseName,
                          coursePrefix: offering._coursePrefix || course._coursePrefix,
                          coursePrefixDisplayLabel:
                            offering._coursePrefixDisplayLabel || course._coursePrefixDisplayLabel,
                          courseStartDate: offering._courseStartDate,
                          courseType: offering._courseType,
                          courseOfferingName: offering._courseOfferingName,
                          creditEligibilityPrice: offering._creditEligibilityPrice || course._creditEligibilityPrice,
                          credits: offering._asuCredits || course._asuCredits
                        },
                        denyReason: null
                      };
                    }
                  }
                }
              }
            }
          }
        }

        // If not found in pathway courses, try to find from course list
        if (this.$conn.courseList && this.$conn.courseList.degrees) {
          let courseListOfferingIds = [];
          for (const degree of this.$conn.courseList.degrees) {
            if (degree.courses) {
              for (const course of degree.courses) {
                courseListOfferingIds.push(course._courseOfferingId);
                if (course._courseOfferingId === courseOfferingId) {
                  return {
                    courseOfferingId: course._courseOfferingId,
                    courseOfferingCanvasId: course._canvasCourseId,
                    courseInfo: {
                      courseName: course._courseName,
                      coursePrefix: course._coursePrefix,
                      coursePrefixDisplayLabel: course._coursePrefixDisplayLabel,
                      courseStartDate: course._courseStartDate,
                      courseType: course._courseType,
                      courseOfferingName: course._courseOfferingName,
                      creditEligibilityPrice: course._creditEligibilityPrice,
                      credits: course._asuCredits
                    },
                    denyReason: null
                  };
                }
              }
            }
          }
        }

        const searchIds = [
          courseOfferingId,
          String(courseOfferingId),
          Number(courseOfferingId),
          parseInt(courseOfferingId)
        ].filter((id) => id != null && !isNaN(id) && id !== '');

        // Search pathways with all variations
        if (this.$conn.pathwayCourseList && this.$conn.pathwayCourseList._pathwayCourses) {
          for (const pathway of this.$conn.pathwayCourseList._pathwayCourses) {
            if (pathway._pathwayCourses) {
              for (const course of pathway._pathwayCourses) {
                if (course._courseOfferingData) {
                  for (const offering of course._courseOfferingData) {
                    if (searchIds.some((searchId) => offering._courseOfferingId == searchId)) {
                      return {
                        courseOfferingId: offering._courseOfferingId,
                        courseOfferingCanvasId: offering._canvasCourseId,
                        courseInfo: {
                          courseName: offering._courseName || course._courseName,
                          coursePrefix: offering._coursePrefix || course._coursePrefix,
                          coursePrefixDisplayLabel:
                            offering._coursePrefixDisplayLabel || course._coursePrefixDisplayLabel,
                          courseStartDate: offering._courseStartDate,
                          courseType: offering._courseType,
                          courseOfferingName: offering._courseOfferingName,
                          creditEligibilityPrice: offering._creditEligibilityPrice || course._creditEligibilityPrice,
                          credits: offering._asuCredits || course._asuCredits
                        },
                        denyReason: null
                      };
                    }
                  }
                }
              }
            }
          }
        }

        // Search course list with all variations
        if (this.$conn.courseList && this.$conn.courseList.degrees) {
          for (const degree of this.$conn.courseList.degrees) {
            if (degree.courses) {
              for (const course of degree.courses) {
                if (searchIds.some((searchId) => course._courseOfferingId == searchId)) {
                  return {
                    courseOfferingId: course._courseOfferingId,
                    courseOfferingCanvasId: course._canvasCourseId,
                    courseInfo: {
                      courseName: course._courseName,
                      coursePrefix: course._coursePrefix,
                      coursePrefixDisplayLabel: course._coursePrefixDisplayLabel,
                      courseStartDate: course._courseStartDate,
                      courseType: course._courseType,
                      courseOfferingName: course._courseOfferingName,
                      creditEligibilityPrice: course._creditEligibilityPrice,
                      credits: course._asuCredits
                    },
                    denyReason: null
                  };
                }
              }
            }
          }
        }

        // If not found in loaded data, try fetching from API
        try {
          const apiCourseOffering = await this.fetchCourseOfferingFromAPI(courseOfferingId);
          if (apiCourseOffering) {
            return apiCourseOffering;
          }
        } catch (apiError) {
          this.logError('API fetch failed:', apiError);
        }

        return null;
      } catch (error) {
        this.logError('Error finding course offering:', error);
        return null;
      }
    },

    /**
     * Fetch course offering from API when not found in loaded data structures
     */
    async fetchCourseOfferingFromAPI(courseOfferingId) {
      try {
        if (!this.$conn.learnerData) {
          return null;
        }

        // Try to fetch from the degree courses API and search for the specific offering
        const resolvedProxyAsurite = await this.$conn.getResolvedProxyAsurite();
        const apiPath = resolvedProxyAsurite
          ? `/api/degree-courses?partnerId=${this.$conn.learnerData.partnerId}&proxyAsurite=${encodeURIComponent(resolvedProxyAsurite)}`
          : `/api/degree-courses?partnerId=${this.$conn.learnerData.partnerId}`;

        const response = await this.$conn._doConnect(apiPath, 'get', this.$conn.learnerData.basicLearnerInformation);

        if (response && response.data && response.data.degrees) {
          // Search through all degrees and courses for the matching course offering ID
          for (const degree of response.data.degrees) {
            if (degree.courses) {
              for (const course of degree.courses) {
                if (course._courseOfferingData) {
                  for (const offering of course._courseOfferingData) {
                    // Convert both to strings for comparison
                    const offeringId = String(offering._courseOfferingId || '');
                    const searchId = String(courseOfferingId);

                    if (offeringId === searchId) {
                      // Return the course with the matching offering
                      return {
                        ...course,
                        _selectedOffering: offering,
                        _courseOfferingId: offering._courseOfferingId
                      };
                    }
                  }
                }
              }
            }
          }
        }

        // Also try pathway courses API if available
        if (this.$conn.learnerData.pathwayId) {
          const pathwayApiPath = `/api/degree-courses/pathways?partnerId=${this.$conn.learnerData.partnerId}&pathwayId=${this.$conn.learnerData.pathwayId}`;

          const pathwayResponse = await this.$conn._doConnect(
            pathwayApiPath,
            'get',
            this.$conn.learnerData.basicLearnerInformation
          );

          if (pathwayResponse && pathwayResponse.data && pathwayResponse.data._pathwayCourses) {
            for (const pathwayCourse of pathwayResponse.data._pathwayCourses) {
              if (pathwayCourse._courseOfferingData) {
                for (const offering of pathwayCourse._courseOfferingData) {
                  const offeringId = String(offering._courseOfferingId || '');
                  const searchId = String(courseOfferingId);

                  if (offeringId === searchId) {
                    return {
                      ...pathwayCourse,
                      _selectedOffering: offering,
                      _courseOfferingId: offering._courseOfferingId
                    };
                  }
                }
              }
            }
          }
        }

        return null;
      } catch (error) {
        return null;
      }
    },

    /**
     * ACC-389: Ask the backend whether the learner may self-enroll into this offering.
     * PartnerPay (program-supported) courses are partner-enrolled only. Fails open so a
     * transient error never blocks enrollment — the POST /api/enrollments guard remains
     * the authoritative backstop.
     *
     * @returns {Promise<{allowed: boolean, reason: string|null}>}
     */
    async checkSelfEnrollEligibility(courseOfferingId) {
      try {
        const learnerId = this.$conn.learnerData?._learnerId || this.$conn.learnerData?._learnerApplicationId;
        if (!learnerId || !courseOfferingId) return { allowed: true, reason: null };

        const apiPath = `/api/enrollments/self-enroll-eligibility?learnerId=${encodeURIComponent(
          learnerId
        )}&courseOfferingId=${encodeURIComponent(courseOfferingId)}`;

        const response = await this.$conn._doConnect(apiPath, 'get', this.$conn.learnerData.basicLearnerInformation);

        // _doConnect returns the axios response; the body may be the payload directly
        // or the raw Lambda envelope ({ statusCode, body: '<json>' }).
        let payload = response?.data;
        if (payload && typeof payload.body === 'string') {
          try {
            payload = JSON.parse(payload.body);
          } catch (e) {
            payload = response?.data;
          }
        }

        if (payload && typeof payload.allowed === 'boolean') return payload;
        return { allowed: true, reason: null };
      } catch (error) {
        this.logError('Self-enroll eligibility check failed (failing open):', error);
        return { allowed: true, reason: null };
      }
    },

    /**
     * ACC-389: Gate the deep-link checkout. If the learner may not self-enroll into the
     * course (program-supported / PartnerPay), show the popup instead of proceeding to
     * checkout — this runs BEFORE any PayPal capture. Otherwise set checkout data and
     * navigate as before. Returns true when navigation happened.
     */
    async navigateToCheckoutGuarded(checkoutData) {
      const eligibility = await this.checkSelfEnrollEligibility(checkoutData.courseOfferingId);

      if (!eligibility.allowed) {
        this.showProgramSupportedDeeplinkBlock();
        return false;
      }

      const checkoutStore = useCheckoutStore();
      checkoutStore.setCheckoutData(checkoutData);
      this.$router.push({ name: 'courseCheckout' });
      return true;
    },

    /**
     * ACC-389: Surface the program-supported popup and clear the pending deep-link course
     * offering + query param so the dashboard does not loop back into checkout.
     */
    showProgramSupportedDeeplinkBlock() {
      this.$conn.learnerData._courseOffering = null;
      if (this.$route.query.course_offering_id) {
        const query = { ...this.$route.query };
        delete query.course_offering_id;
        this.$router.replace({ query });
      }
      // ACC-408: highest non-blocker priority (90) — honors explicit user intent
      // (the learner followed a course deep-link), so it shows ahead of any
      // celebration or nag.
      this.modalQueue.requestShow({ id: 'partner-pay-deeplink', priority: 90 });
    },

    /**
     * ACC-389: popup CTA — send the learner to the add-courses page where the same course
     * can be added under "Pay to enroll" (self-pay), the only learner-initiated path.
     */
    goToPayToEnrollCourses() {
      this.modalQueue.dismiss('partner-pay-deeplink');
      this.$router.push({ path: '/courses-add' });
    },

    handleAddCoursesClick() {
      this.asuoDataLayerClick('MyCourses', '0', {
        region: 'main content',
        section: 'my current courses',
        text: 'add courses'
      });
      this.$router.push('/courses-add');
    },

    /**
     * Mark enrolled courses that align with the user's pathway
     * Uses lightweight /api/pathways/course-prefixes endpoint
     * Checks both course prefixes and credit designations
     */
    async markPathwayCourses() {
      try {
        // Use lightweight endpoint to get pathway course prefixes and designations
        const pathwayData = await this.$conn.getPathwayCoursePrefixes();

        if (!pathwayData.enrolled) {
          return;
        }

        // Build sets for quick lookup
        const pathwayPrefixes = new Set(pathwayData.prefixes || []);
        const allDesignations = new Set([
          ...(pathwayData.designations?.required || []),
          ...(pathwayData.designations?.recommended || [])
        ]);

        // Helper to parse designation codes from string like "SCIT: Science\nHUAD: Humanities"
        const parseDesignationCodes = (designationString) => {
          if (!designationString || typeof designationString !== 'string') return [];
          return designationString
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line)
            .map((line) => {
              const colonIndex = line.indexOf(':');
              return colonIndex > 0 ? line.substring(0, colonIndex).trim() : line.trim();
            });
        };

        // Mark enrolled courses that match pathway prefixes or designations
        let marked = false;
        (this.course_sections || []).forEach((course_section) => {
          (course_section.courses || []).forEach((course) => {
            const courseInfo = course._courseInfo || {};
            const coursePrefix = courseInfo._coursePrefix;
            const courseDesignationsRaw = courseInfo._courseDesignations || '';

            // Check if course prefix matches
            if (coursePrefix && pathwayPrefixes.has(coursePrefix)) {
              course._isPathwayCourse = true;
              marked = true;
              return;
            }

            // Check if any course designation matches pathway designations
            if (courseDesignationsRaw && allDesignations.size > 0) {
              const courseDesignationCodes = parseDesignationCodes(courseDesignationsRaw);
              const hasMatchingDesignation = courseDesignationCodes.some((d) => allDesignations.has(d));
              if (hasMatchingDesignation) {
                course._isPathwayCourse = true;
                marked = true;
              }
            }
          });
        });

        // Force Vue reactivity update by reassigning the array
        if (marked) {
          this.course_sections = [...this.course_sections];
        }
      } catch (error) {
        this.logError('markPathwayCourses', error);
      }
    },
    async closeCreditRequestError() {
      await this.reloadDashboardOrPathway(true);
      this.showCreditRequestError = !this.showCreditRequestError;
    },
    alreadyRequestedForCredit() {
      this.showCreditRequestError = true;
    },
    shouldShowSupportCoachBox() {
      return (
        ((this.$conn.learnerData._coachDetails || {}).ShowSuccessCoach || false) &&
        ((this.$conn.learnerData._coachDetails || {}).IsContactOwnerSupportCoach || false)
      );
    },
    reloadDashboardOrPathway(event) {
      if (event) {
        this.getEnrollments((enrollments) => {});
      }
    },

    /**
     * Handle pathway enrollment/unenrollment events
     * Refreshes pathway data from backend without a full page reload
     */
    async handlePathwayChange() {
      try {
        // Re-fetch via the dashboard endpoint (same source as a page refresh) so the
        // pathway data includes enriched_courses (recommended courses). The lighter
        // getMyPathway() endpoint skips enrichment, which left a newly added pathway
        // showing "No recommended courses available" until a refresh (ULC-3044).
        await this.loadDashboardSections();
      } catch (error) {
        this.logError('Dashboard - Failed to reload pathway data', error);
      } finally {
      }
    },

    /**
     * Handle pathway enrollment from URL parameter (redirected from PathwayDetailsSidebar)
     * @param {string} pathwayId - The pathway ID to enroll in
     */
    async handleEnrollPathwayFromUrl(pathwayId) {
      const uiStore = useUiStore();
      const pathwaysStore = usePathwaysStore();

      // Check if user is already enrolled in a pathway
      if (pathwaysStore.isEnrolled) {
        const currentPathwayName = pathwaysStore.getEnrolledPathway?.pathwayName || 'your current pathway';
        uiStore.showWarningNotification(
          'Already Enrolled',
          `Please unenroll from ${currentPathwayName} before enrolling in a new pathway.`
        );
        return;
      }

      try {
        uiStore.setLoadingState('enrolling');

        // Get user's contactId or asurite
        const contactId = this.$conn.learnerData?._contactId || this.$conn.learnerData?.contactId;
        const asurite = this.$conn.learnerData?._asuRite || this.$conn.learnerData?.asuRite;

        const identifier = contactId ? { contactId } : asurite ? { asuRite: asurite } : null;

        if (!identifier) {
          throw new Error('User identifier not found');
        }

        // Call the pathway enrollment API
        await this.$conn.updatePathwayConnection(identifier, {
          pathwayId: pathwayId
        });

        // Refresh pathway data via the dashboard endpoint so enriched_courses
        // (recommended courses) are populated, matching a page refresh (ULC-3044).
        await this.loadDashboardSections();

        // Get the enrolled pathway name for the notification
        const enrolledPathway = pathwaysStore.getEnrolledPathway;
        const pathwayName = enrolledPathway?.pathwayName || 'your selected pathway';

        // Show success notification
        uiStore.showSuccessNotification(`Pathway to ${pathwayName}`, 'has been added to your dashboard.');
      } catch (error) {
        this.logError('Dashboard - Failed to enroll in pathway from URL', error);

        // Check for specific error messages from the backend
        const errorMessage = error?.response?.data?.message || error?.message || '';

        if (errorMessage.includes('not authorized to enroll') || errorMessage.includes('Partner is not authorized')) {
          uiStore.showErrorNotification(
            'Pathway Not Available',
            'This pathway is not available for your account. Please choose a different pathway.'
          );
        } else {
          uiStore.showErrorNotification('Enrollment Failed', 'Failed to enroll in pathway. Please try again.');
        }
      } finally {
        uiStore.setLoadingState(null);
      }
    },

    openCloseUnenrollModel(event) {
      if (event) this.courseUnenrollInfo = event.courseUnenrollInfo;

      // setTimeout(() => {
      this.unenrollCourse = !this.unenrollCourse;

      // }, 100);
    },
    profileCompletionDeadline() {
      var firstLogin = new Date(this.$conn.learnerData._firstPortalSignIn);
      var today = new Date();

      return Math.abs(today - firstLogin) / (1000 * 60 * 60 * 24);
    },

    // ACC-408: fire a celebration's confetti the moment it becomes the current
    // queue item. Requesting only enqueues it — a higher-priority modal (or the
    // consent-gate blocker) may hold it back, and its <canvas> only mounts once
    // it is current, so the animation must be driven off `current`, not the request.
    // (POK is not handled here — PokCertificateDialog fires its own confetti when
    // its :visible prop, bound to isCurrent('pok-cert'), becomes true.)
    onModalQueueShow(id) {
      if (id === 'celebrate-event') {
        this.showCanvasElement = true;
        this.showConfetti(this.pendingCelebrateEvent);
      } else if (id === 'course-completion') {
        this.showCanvasElement = true;
        this.showConfetti();
      }
    },

    updateProfile() {
      this.modalQueue.dismiss('profile-reminder');
      setTimeout(() => {
        this.completeProfile = !this.completeProfile;
      }, 500);
    },

    async reloadDemographicInfo(event) {
      if (event) {
        await this.$conn
          .getLearnerDetails(this.$auth.getUserId())
          .then(() => {})
          .catch(() => {})
          .finally(() => {});
        this.demographicInfo = this.$conn.getDemographicInformation();
      }
    },
    prepareCanvasBody(learner) {
      let canvasBody = {
        user: {},
        pseudonym: {},
        communication_channel: {}
      };
      let name = learner._firstName + ' ' + learner._lastName;
      canvasBody.user['name'] = name;
      canvasBody.user['short_name'] = name;
      canvasBody.user['sortable_name'] = name;
      canvasBody.user['skip_registration'] = true;
      canvasBody.pseudonym['unique_id'] = learner._asuRite;
      canvasBody.pseudonym['sis_user_id'] = `edplusasu-${learner._asuRite}`;
      canvasBody.pseudonym['send_confirmation'] = false;
      canvasBody.pseudonym['authentication_provider_id'] = '147';
      canvasBody.communication_channel['type'] = 'email';
      canvasBody.communication_channel['address'] = learner._emailId;
      canvasBody.force_validations = false;

      return canvasBody;
    },

    closeConfettiDialog() {
      this.modalQueue.dismiss('celebrate-event');

      try {
        this.$conn.closeConfettiDialogMessage({
          isConfettiUp: true
        });
      } catch (error) {
        // eslint-disable-next-line no-console
      }
    },

    /**
     * Handler for the PokCertificateDialog @close event.
     * Persists the one-time DB flag and optimistically updates local state.
     */
    onPokCertificateDialogClose(connectionId) {
      this.modalQueue.dismiss('pok-cert');

      if (connectionId) {
        const learnerId =
          this.$conn.learnerData?._learnerId ||
          this.$conn.learnerData?._learnerApplicationId ||
          this.$conn.learnerData?.learnerId ||
          this.$conn.learnerData?.learnerApplicationId;

        // P1: only send if learnerId is present — without it the IDOR ownership check fails
        if (learnerId) {
          this.$conn.markPokConfettiShown({ connection_id: connectionId, ea_learner_application: learnerId });
        }

        // Optimistically mark it in the local list so a same-session re-render
        // doesn't re-trigger the confetti before the next full fetch
        this.myCertificates = this.myCertificates.map((cert) =>
          cert.connection_id === connectionId ? { ...cert, pok_confetti_shown: true } : cert
        );

        // Re-poll Aether so the NEXT certificate's confetti can fire in the same session

        if (learnerId) {
          this._fetchAndMergePokCredentials(learnerId).catch((err) =>
            this.logError('Failed to fetch POK credentials', err)
          );
        }
      }
    },

    closePathwaysConfettiDialog() {
      // Note: the pathway-completion modal (v-if="isPathwayCompleted") is currently
      // dead code and is not on the modal queue; left as-is intentionally.
      try {
        this.$conn.patchLearnersInfo({
          isConfettiUp: true,
          pathway: this.pathwayId
        });
      } catch (error) {
        // eslint-disable-next-line no-console
      }
    },

    closeCourseCompletionConfettiDialog() {
      this.modalQueue.dismiss('course-completion');
      const completedCoursesInfo = this.completedCoursesForConfetti.map((course) => course.courseCompletionInfo);
      if (completedCoursesInfo.length > 0) {
        try {
          this.$conn.patchLearnersInfo({
            completedCourseUpdateConfetti: completedCoursesInfo
          });
        } catch (error) {
          // eslint-disable-next-line no-console
        }
      }
    },

    scrollToId(id) {
      let pos = document.getElementById(id) != null ? document.getElementById(id).offsetTop : '';

      if (id == 'courses' || id == 'resources') {
        window.scrollTo(0, pos - 50);
      } else if (id == 'calendar') {
        window.scrollTo(0, pos - 90);
      } else if (id == 'progress') {
        window.scrollTo(0, pos - 80);
      } else {
        window.scrollTo(0, pos - 70);
      }
    },

    shouldRemoveCreditTracker() {
      return shouldRemoveCreditTracker(this.$conn.learnerData);
    },

    clear() {
      this.$router.push({ name: 'login' });
    },

    isDateBetween(dateToCompare, startDate, endDate) {
      return dateToCompare.getTime() > startDate.getTime() && dateToCompare.getTime() < endDate.getTime();
    },

    isDateInPast(dateToCompare, futureDate) {
      return dateToCompare.getTime() < futureDate.getTime();
    },

    navigateTo(url) {
      window.open(url, '_blank');
    },

    isAnyCreditCompleted(dashboard) {
      return dashboard.numberOfCreditsCompleted > 0;
    },

    /**
     * Should always have the enrollmentId. Then match against the enrollment from coursesStore
     *
     * @param event
     */
    async doUnenroll(event) {
      try {
        const coursesStore = useCoursesStore();
        const usersStore = useUserStore();

        let enrollmentToUnenroll = coursesStore.enrollments.find((e) => e._enrollmentId === event.enrollmentId);

        if (!enrollmentToUnenroll) {
          this.logInfo('dounenroll - enrollment not found for id ' + event.enrollmentId);

          throw new Error('Enrollment not found for id ' + event.enrollmentId);
        }

        await this.$conn.unenrollCourse({
          learnerId: usersStore.apis.learnerData._learnerId,
          enrollmentId: enrollmentToUnenroll._enrollmentId,
          courseOfferingId: enrollmentToUnenroll._courseOfferingId,
          enrollmentStatus: 'Inactive'
        });

        // spinner loader will be cleared here
        this.getEnrollments(() => {});

        // Show unenroll reason/feedback form
        if (event.callback && typeof event.callback === 'function') event.callback();
      } catch (error) {
        this.logError('dounenroll failed', error);
      }
    },

    stickyHeaderOnScroll() {
      var header = document.getElementById('myHeader');
      if (header) {
        var sticky = header.offsetTop + 40;
        if (window.pageYOffset > sticky) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      }

      // Update active section based on scroll position
      this.updateActiveSection();
    },

    updateActiveSection() {
      const scrollPosition = window.pageYOffset + 150; // Offset for header

      // Find which section is currently in view
      for (let i = this.allSections.length - 1; i >= 0; i--) {
        const section = this.allSections[i];
        const element = document.getElementById(section.id);

        if (element && element.offsetTop <= scrollPosition) {
          if (this.activeSection !== section.index) {
            this.activeSection = section.index;
          }
          break;
        }
      }
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      let offset = 50;

      // Special handling for different sections
      if (sectionId === 'pathway') {
        offset = 80;
      } else if (sectionId === 'calendar') {
        offset = 90;
      } else if (sectionId === 'progress') {
        offset = 80;
      } else if (sectionId === 'resources') {
        offset = 100;
      }

      if (element) {
        const position = element.offsetTop - offset;
        window.scrollTo({ top: position, behavior: 'smooth' });

        // Update active section immediately on click
        const clickedSection = this.allSections.find((s) => s.id === sectionId);
        if (clickedSection) {
          this.activeSection = clickedSection.index;
        }
      }
    },

    runConfetti() {
      var canvas = document.getElementById('canvas');

      var myConfetti = confetti.create(canvas, {
        resize: true,
        useWorker: true
      });

      myConfetti({
        particleCount: 400,
        origin: {
          y: 0.55
        },
        startVelocity: 30,
        spread: 240
        // any other options from the global
        // confetti function
      });
    },

    showConfetti(celebrateEvent) {
      const x = setInterval(() => {
        this.runConfetti();
      }, 800);

      setTimeout(() => {
        clearInterval(x);
        if (celebrateEvent) {
          const userStore = useUserStore();
          userStore.apis.learnerData._celebrateEvent = false;
        }
      }, 2400);

      setTimeout(() => {
        this.showCanvasElement = false;
      }, 4800);

      if (celebrateEvent) {
        this.celebrateEventMessage = celebrateEvent.message;
      }
    },

    showCourseCompletionConfetti(enrollments) {
      return enrollments.filter(
        (e) =>
          e._courseCompletedDate &&
          (e._creditEligible || '').toLowerCase() === 'y' &&
          !e._courseCompletionConfetti &&
          (e._creditConverted || '').toLowerCase() !== 'y' &&
          this.courseCompletionConfettiTermBased(e)
      );
    },

    courseCompletionConfettiTermBased(enrollment) {
      // OS-4126 updated req for Self Paced course
      if (((enrollment || {})._courseInfo || {})._term === 'Self Paced') {
        return (
          // Not to show Confetti for courses that were completed previous to Mar 24th, 2022
          new Date(enrollment._courseCompletedDate).getDate() >= 24 &&
          new Date(enrollment._courseCompletedDate).getMonth() + 1 > 2 &&
          new Date(enrollment._courseCompletedDate).getFullYear() >= 2022
        );
      } else {
        // Not to show Confetti for courses that were completed previous to Mar, 2022
        return (
          new Date(((enrollment || {})._courseInfo || {})._courseStartDate).getMonth() + 1 > 2 &&
          new Date(((enrollment || {})._courseInfo || {})._courseStartDate).getFullYear() >= 2022
        );
      }
    },

    dismissToast() {
      this.asuoDataLayerClick('Dashboard', '30');
      this.toastDismissedLocal = true;
      try {
        localStorage.setItem(this.toastDismissKey, 'true');
      } catch {
        // localStorage unavailable
      }
    },
    scrollToDates() {
      this.asuoDataLayerClick('Dashboard', '29');
      const el = document.getElementById('calendar');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    showProfileUpdateRemainder() {
      return new Promise((resolve) => {
        let i = setInterval(() => {
          if (!this.resultsFetched) return;
          clearInterval(i);

          // ACC-408: the profile reminder is a queued nag (priority 40) with a 12h
          // per-learner cooldown. Eligibility is passed as canShow so the queue
          // re-checks it at show time (after the consent-gate blocker clears and
          // any higher-priority celebration has been dismissed). The gate is no
          // longer checked here — the queue pauses while the blocker is active.
          this.modalQueue.requestShow({
            id: 'profile-reminder',
            priority: 40,
            cooldownMs: 12 * 60 * 60 * 1000,
            persistKey: this.$auth.getUserId(),
            canShow: () =>
              this.$conn.learnerData['_collectDemographicInfo'] &&
              this.profileCompletionProgress !== 100 &&
              this.profileCompletionDeadline() > 14
          });

          resolve();
        }, 100);
      });
    }
  },

  async created() {
    window.addEventListener('scroll', this.stickyHeaderOnScroll);

    // ACC-408: drive each queued celebration's confetti off the current modal.
    // Registered before any requestShow below so the first show is not missed.
    this.$watch(
      () => this.modalQueue.current,
      (id) => this.onModalQueueShow(id)
    );

    // Check for pathway enrollment/unenrollment notifications
    this.checkPathwayNotifications();

    this.resourcesContent = [
      {
        title: 'Frequently Asked Questions',
        navigateTo: this.ulcPartnerFlag ? 'https://ulc.asu.edu/about/faq/' : 'https://ea.asu.edu/about/faq/',
        dataLayerPointer: '12',
        text: `Get answers to your most <span><a href="${
          this.ulcPartnerFlag ? 'https://ulc.asu.edu/about/faq/' : 'https://ea.asu.edu/about/faq/'
        }" target="_blank" class="font-weight-bold" style="color:#8c1d40; border-bottom:2px solid #8c1d40">Frequently Asked Questions</a><span> regarding Universal Learner Courses.`
      },
      {
        title: 'Learner Support',
        navigateTo: 'https://tutoring.asu.edu/online-study-hub',

        // dataLayerPointer: '9',
        text: `<span><a  href="https://tutoring.asu.edu/online-study-hub" target="_blank" class="font-weight-bold" style="color:#8c1d40; border-bottom:2px solid #8c1d40">Online Study Hub</a><span> is available to Universal Learners for academic support.<br/><br/><span><a href="${
          this.ulcPartnerFlag
            ? 'https://ulc.asu.edu/help-center/accessibility/'
            : 'https://ea.asu.edu/help-center/accessibility/'
        }" target="_blank" class="font-weight-bold" style="color:#8c1d40; border-bottom:2px solid #8c1d40">Student Accessibility and Inclusive Learning Services (SAILS)</a></span> provides support to ensure accessibility. <br/><br/><span><a href="https://currentstudent.asuonline.asu.edu/student-services/360-life-services/" target="_blank" class="font-weight-bold" style="color:#8c1d40; border-bottom:2px solid #8c1d40">360 Life Services</a></span> provides comprehensive resources and support, including 24/7 counseling.`
      },
      // {
      //   title: 'Help with Course Selection',
      //   navigateTo: 'https://ea.asu.edu/courses',
      //   dataLayerPointer: '1',
      //   text: 'Register for a <a href="https://pff.asu.edu/degree-pathways/" target="_blank" class="font-weight-bold" style="color:#8c1d40; border-bottom:2px solid #8c1d40">Degree Pathway</a> to view recommended courses for your program of interest.'
      // },
      {
        title: 'Transfer Credit Services',
        navigateTo: 'https://transferguide.apps.asu.edu/app/home',
        dataLayerPointer: '7',
        text: 'Use the <a  href="https://transferguide.apps.asu.edu/app/home" target="_blank" class="font-weight-bold" style="color:#8c1d40 ; border-bottom:2px solid #8c1d40">Transfer Credit Guide</a> to make sure you don’t take the same course twice.<br/><br/>Visit <a href="https://registrar.asu.edu/transcripts" target="_blank" class="font-weight-bold" style="color:#8c1d40 ; border-bottom:2px solid #8c1d40">University Registrar Services</a> to request official and unofficial ASU academic transcripts.'
      },
      {
        title: 'Technology Requirements',
        navigateTo: 'https://ulc.asu.edu/technical-requirements/',
        dataLayerPointer: '8',
        text: 'Check out our <a  href="https://ulc.asu.edu/technical-requirements/" target="_blank"  class="font-weight-bold" style="color:#8c1d40 ; border-bottom:2px solid #8c1d40">technical requirements</a> to be sure you have what’s needed.'
      },
      // {
      //   title: 'ASU 360 Life Services',
      //   navigateTo: 'https://goto.asuonline.asu.edu/360lifeservices/',
      //   dataLayerPointer: '10',
      //   text: 'Feeling overwhelmed? ASU’s <a  href="https://goto.asuonline.asu.edu/360lifeservices/" target="_blank" class="font-weight-bold" style="color:#8c1d40 ; border-bottom:2px solid #8c1d40">360 Life Services</a> provides free comprehensive resources and support, including 24/7 counseling.'
      // },
      {
        title: 'Apply for Financial Aid',
        navigateTo: 'https://tuition.asu.edu/financial-aid/fafsa',
        dataLayerPointer: '11',
        text: 'While a <span><a  href="https://tuition.asu.edu/financial-aid/fafsa" target="_blank" class="font-weight-bold" style="color:#8c1d40 ; border-bottom:2px solid #8c1d40">Free Application for Federal Student Aid</a></span> is not required for Pathway to Admission, Starbucks requires that you have a completed FAFSA on file once you are admitted to ASU.',
        partnersOnly: ['Starbucks Partners']
      }
    ];

    this.awaitPageLoad(
      this.pageLoad,
      'dashboard',
      async () => {
        if (!this.$conn.learnerData) {
          const uiStore = useUiStore();
          uiStore.showErrorNotification('Error', 'Unable to load learner data. Please try again later.');

          return;
        }

        // Check for pending certificate registration AFTER learner data is loaded
        const certificateFromUrl = this.$route.query.certificate;
        const certificateFromSession = sessionStorage.getItem('pendingCertificate');
        const pendingCertificate = certificateFromUrl || certificateFromSession;

        if (pendingCertificate) {
          // Remove from sessionStorage to prevent duplicate registrations
          sessionStorage.removeItem('pendingCertificate');

          // Clean URL if certificate came from query params
          if (certificateFromUrl) {
            const query = { ...this.$route.query };
            delete query.certificate;
            this.$router.replace({ name: 'dashboard', query });
          }

          // If viewAs is also present, defer certificate registration until after
          // view-as is established (otherwise it registers under the admin's account)
          if (this.$route.query['viewAs']) {
            this.pendingViewAsCertificate = pendingCertificate;
          } else {
            // Register for certificate now that learner data is available
            await this.registerForCertificate(pendingCertificate);
          }
        }

        // Await the dashboard call that was fired in parallel with enrollments
        await this._dashboardPromise;

        // Check if courseOffering is present and redirect to courseCheckout
        if (this.$conn.learnerData.courseOffering) {
          const learnerData = this.$conn.learnerData;
          const courseOffering = learnerData.courseOffering;

          // Populate checkout store with course data
          const checkoutData = {
            title: courseOffering.courseInfo.courseName || '',
            coursePrefix: courseOffering.courseInfo.coursePrefix || '',
            coursePrefixDisplayLabel: courseOffering.courseInfo.coursePrefixDisplayLabel || '',
            courseStartDate: courseOffering.courseInfo.courseStartDate || '',
            courseEndDate: courseOffering.courseInfo.courseEndDate || '',
            courseType: courseOffering.courseInfo.courseType,
            benefitsEligible: false,
            benefitType: '',
            enrollmentId: '0',
            buttonLabel: 'Access Course',
            buttonAction: 'Access Course',
            courseOfferingId: courseOffering.courseOfferingId,
            courseOfferingName: courseOffering.courseInfo.courseOfferingName || '',
            creditEligibilityPrice: courseOffering.courseInfo.creditEligibilityPrice,
            canvasEnrollmentId: 0,
            canvasUserId: learnerData.canvasUserId,
            canvasCourseId: courseOffering.courseOfferingCanvasId,
            credits: courseOffering.courseInfo.credits,
            from: 'dashboard',
            enrollmentType: 'new',
            errorMessage: courseOffering.denyReason
          };

          // Clear courseOffering from learner data to prevent redirect loop
          this.$conn.learnerData._courseOffering = null;

          // ACC-389: gate self-enroll into program-supported (PartnerPay) courses BEFORE
          // navigating to checkout (PayPal captures before the enrollment POST).
          await this.navigateToCheckoutGuarded(checkoutData);
          return;
        } else if (this.$route.query.course_offering_id) {
          // Clear stale course offering data that doesn't match the requested ID
          this.$conn.learnerData._courseOffering = null;
          // Continue with course_offering_id processing logic below
        }

        this.orientationCourse = this.$conn.partnerData.orientation;

        this.earnedCredits = this.$conn.learnerData.dashboardPageData.numberOfCreditsCompleted;
        this.totalCredits = this.$conn.learnerData.dashboardPageData.numberOfCreditsNeeded;

        const userStore = useUserStore();
        const coursesStore = useCoursesStore();

        this.partnerName = userStore.welcomePageData.partnerName;
        this.pathwayId = userStore.apis.learnerData.pathwayId;
        this.pathway = userStore.apis.learnerData.pathwayName;
        this.isPathwayConfettiFired = userStore.apis.learnerData.isPathwayConfettiFired;

        this.pathwayCompletionDate = userStore.apis.learnerData.pathwayCompletionDate;
        this.noOfCourses.totalCourses = coursesStore.enrollments?.length || 0;
        let celebrateEvent = ((userStore.apis || {}).learnerData || {})._celebrateEvent || {};

        this.demographicInfo = this.$conn.getDemographicInformation();
        this.basicLearnerInfo = this.$conn.getBasicLearnerInfo();
        this.educationalInfo = this.$conn.getEducationalInformation();
        this.collectDemographicInfo = (this.$conn.learnerData || {})._collectDemographicInfo;

        // Handle pathway enrollment from sessionStorage (set by /register?pathway= or PathwayDetailsSidebar)
        const pendingPathway = sessionStorage.getItem('pendingPathway');
        if (pendingPathway) {
          sessionStorage.removeItem('pendingPathway');
          await this.handleEnrollPathwayFromUrl(pendingPathway);
        }

        // ACC-408: celebrations are queued (priority pok-cert 60 > course-completion
        // 55 > celebrate-event 50) and shown one at a time. Each one's confetti fires
        // when it becomes the current modal (see onModalQueueShow), not here. The
        // consent-gate blocker suppresses them while the gate is up, so the old
        // per-modal #1618 check is gone.
        if (celebrateEvent.display && celebrateEvent.message) {
          this.pendingCelebrateEvent = celebrateEvent;
          this.celebrateEventMessage = celebrateEvent.message;
          this.modalQueue.requestShow({ id: 'celebrate-event', priority: 50 });
        }

        // Show confetti anytime a learner becomes credit eligible for a course start
        let showConfettiForCourses = this.showCourseCompletionConfetti(coursesStore.enrollments);
        if (showConfettiForCourses.length > 0) {
          this.completedCoursesForConfetti = showConfettiForCourses;
          this.modalQueue.requestShow({ id: 'course-completion', priority: 55 });
        }

        // Show confetti anytime a learner becomes credit eligible for a course end

        // if (this.pathwayId && !this.isPathwayConfettiFired) {
        //   this.getPathwayDegrees(() => {
        //     this.isPathwayCompleted =
        //       (this.pathway_courses_sections || []).length > 0
        //         ? (this.pathway_courses_sections[2].courses || []).length === this.$store.state.pathwayTotalMandateCourse
        //         : false;

        //     if (this.isPathwayCompleted) {
        //       this.showConfetti();
        //     }
        //     this.urlNavigationParam = this.$store.state.pathwayDegreeCourses.pathwayCourses
        //       ? this.$store.state.pathwayDegreeCourses.pathwayCourses._urlNavigationParam
        //       : '';
        //     this.resultsFetched = true;
        //   });
        // } else {
        this.resultsFetched = true;
        // }

        // Initialize notification store with announcements
        const userStore2 = useUserStore();
        this.notificationStore.loadReadState();
        this.notificationStore.setNotifications(
          userStore2.apis.learnerData._studentAnnouncements,
          ((this.$conn.partnerData || {}).dashboardPageData || {}).studentPortalAnnouncement
        );

        // ACC-408: the Announcements tour joins the modal queue as the lowest-priority
        // item (10), so it waits for every other auto-modal. Its config/schedule/seen/
        // View-As gates are the canShow; App.vue launches it once it becomes current.
        this.modalQueue.requestShow({
          id: 'product-tour',
          priority: 10,
          canShow: () => useTour().isAutoStartEligible('announcements')
        });

        const pathwaysStore = usePathwaysStore();
        this.pathwayData = pathwaysStore.myPathway || {};

        Object.keys(localStorage)
          .filter((x) => x.startsWith('paid_'))
          .forEach((x) => localStorage.removeItem(x));

        if (this.$route.query && this.$route.query['viewAs']) {
          const uiStore = useUiStore();
          uiStore.setTriggerViewAs(true);
        }

        // Also check localStorage requestedURL as fallback (for already authenticated users)
        const requestedURL = localStorage.getItem('requestedURL');

        let courseOfferingId = this.$route.query.course_offering_id;
        if (!courseOfferingId && requestedURL) {
          try {
            const urlParts = requestedURL.split('?');
            if (urlParts.length > 1) {
              const requestedParams = new URLSearchParams(urlParts[1]);
              courseOfferingId = requestedParams.get('course_offering_id');
            }
          } catch (error) {
            // Ignore error
          }
        }

        if (courseOfferingId && !this.$conn.learnerData.courseOffering) {
          // ACC-389: gate the deep-link BEFORE resolving the offering. A program-supported
          // (PartnerPay) course must show the popup even when it only resolves via the API
          // fallback (which returns a shape without courseInfo and would otherwise throw
          // while building checkout data, before navigateToCheckoutGuarded runs).
          const deeplinkEligibility = await this.checkSelfEnrollEligibility(courseOfferingId);
          if (!deeplinkEligibility.allowed) {
            this.showProgramSupportedDeeplinkBlock();
            return;
          }

          try {
            // Find course offering by ID from now-loaded courses
            const courseOffering = await this.findCourseOfferingById(courseOfferingId);

            if (courseOffering) {
              // Populate learner data with course offering
              this.$conn.learnerData._courseOffering = courseOffering;

              // Trigger redirect immediately
              const learnerData = this.$conn.learnerData;
              const courseOfferingData = learnerData.courseOffering;

              // Populate checkout store with course data
              const checkoutData = {
                title: courseOfferingData.courseInfo.courseName || '',
                coursePrefix: courseOfferingData.courseInfo.coursePrefix || '',
                coursePrefixDisplayLabel: courseOfferingData.courseInfo.coursePrefixDisplayLabel || '',
                courseStartDate: courseOfferingData.courseInfo.courseStartDate || '',
                courseEndDate: courseOfferingData.courseInfo.courseEndDate || '',
                courseType: courseOfferingData.courseInfo.courseType,
                benefitsEligible: false,
                benefitType: '',
                enrollmentId: '0',
                buttonLabel: 'Access Course',
                buttonAction: 'Access Course',
                courseOfferingId: courseOfferingData.courseOfferingId,
                courseOfferingName: courseOfferingData.courseInfo.courseOfferingName || '',
                creditEligibilityPrice: courseOfferingData.courseInfo.creditEligibilityPrice,
                canvasEnrollmentId: 0,
                canvasUserId: learnerData.canvasUserId,
                canvasCourseId: courseOfferingData.courseOfferingCanvasId,
                credits: courseOfferingData.courseInfo.credits,
                from: 'dashboard',
                enrollmentType: 'new',
                errorMessage: courseOfferingData.denyReason
              };

              // Clear courseOffering from learner data to prevent redirect loop
              this.$conn.learnerData._courseOffering = null;

              // ACC-389: gate self-enroll into program-supported (PartnerPay) courses BEFORE
              // navigating to checkout (PayPal captures before the enrollment POST).
              await this.navigateToCheckoutGuarded(checkoutData);
              return; // Exit early to prevent further processing
            } else {
              // ACC-389: the offering is not available to this learner (not covered) —
              // show the program-supported popup instead of silently dropping the param.
              this.showProgramSupportedDeeplinkBlock();
            }
          } catch (error) {
            this.logError('Error loading course offering:', error);
          }
        }
      },
      () => {
        // Fire dashboard sections fetch in parallel with enrollments (P3 optimization)
        this._dashboardPromise = this.loadDashboardSections(this.dashboardSectionsLoad);
      }
    );
    this.showProfileUpdateRemainder();
  },

  beforeUnmount() {
    // Clean up scroll event listener to prevent memory leaks
    window.removeEventListener('scroll', this.stickyHeaderOnScroll);
  }
});
</script>
